/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './actionTypes';
import {
  generateContractValidationReport,
  generateContractViewReport,
} from '../Components/PDFGenerator';
import { NO_CONTRACT_EXISTS } from '../../../../SharedModules/Errors/constantMessageData';

// Action to dispatch Plan type
export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

// Action to dispatch loading state
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

// Action to set Contract Manufacturer grid
export const setcontractmfggrid = (data) => ({
  type: ActionTypes.SET_CONTRACT_MFG_GRID,
  payload: data,
});

// Action to set Contract Drug grid
export const setcontractdruggrids = (data) => ({
  type: ActionTypes.SET_CONTRACT_DRUG_FAMILY_GRID,
  payload: data,
});

// Action to set open value true/false whicj opens/close addition table grid for druh family and market basket
export const setOpenValue = (data) => ({
  type: ActionTypes.SET_OPEN_VALUE,
  payload: data,
});

// Action to set Market basket grid data
export const setcontractmarketbasketgrid = (data) => ({
  type: ActionTypes.SET_CONTRACT_MARKET_BASKET_GRID,
  payload: data,
});

// Action to set Drug Family Contract Grid data
export const setDrugFamilyContractGrid = (data) => ({
  type: ActionTypes.SET_DRUG_FAMILY_CONTRACT_GRID,
  payload: data,
});

// Action to set Contract grid data
export const setcontractgrid = (data) => ({
  type: ActionTypes.SET_CONTRACT_GRID,
  payload: data,
});

// Action to dispatch rebate program list data
export const dispatchRebatePrograme = (data) => ({
  type: ActionTypes.GET_REBATE_PROGRAM_CONTRACT_REPORT,
  payload: data,
});

// clear out state on close of contract report
export const refreshContractReport = () => ({
  type: ActionTypes.REFRESH_CONTRACT_REPORT,
  payload: {},
});

// Action set errors of the report
export const setErrorMessage = (data) => ({
  type: ActionTypes.SET_ERROR_MESSAGE,
  payload: data,
});

// This action show error message for 5 sec for no contract exists
export const showNoContractMessage = () => (dispatch) => {
  // setTimeout(() => {
    // dispatch(setErrorMessage([]));
  // }, 5000);
  dispatch(
    setErrorMessage([
      {
        field: 'noContractExists',
        message: NO_CONTRACT_EXISTS,
      },
    ])
  );
};

// API call to get the plan types
export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

// API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data.data;
    })
    .catch((response) => {});
};

// API to get contract mfg grid Reports data
export const getcontractmfggrid = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_CONTRACT_MFG_GRID, values)
    .then((response) => {
      dispatch(setLoading(false));
      const data = response?.data?.rebateContractReportVO || [];
      data.sort((a, b) => a.mfgId - b.mfgId);
      dispatch(setcontractmfggrid(data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setcontractmfggrid([]));
    });
};

// API to get contract detail report  data
export const getContractValidationDetails =
  (values, UserDefaultValues, logInUser) => (dispatch) => {
    dispatch(setLoading(true));
    return axios
      .post(serviceEndPoint.GET_CONTRACT_VALIDATION_DETAILS, values)
      .then((response) => {
        dispatch(setLoading(false));

        if (response?.data?.contractValidationDetailsVO?.length > 0) {
          generateContractValidationReport(
            response?.data?.contractValidationDetailsVO[0],
            UserDefaultValues,
            logInUser
          );
        } else {
          dispatch(showNoContractMessage());
        }
      })
      .catch((response) => {
        dispatch(setLoading(false));
      });
  };

// API to get contract drug grids Reports data
export const getcontractdruggrids = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_CONTRACT_DRUG_GRID, values)
    .then((response) => {
      dispatch(setLoading(false));
      const data = response?.data?.contractDrugGridVO || [];
      data.sort((a, b) => a.familySeqNum - b.familySeqNum);
      dispatch(setcontractdruggrids(data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setcontractdruggrids([]));
    });
};

// API to get contract market basketgrid Reports data
export const getcontractmarketbasketgrid = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_CONTRACT_MARKET_BASKET_GRID, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        setcontractmarketbasketgrid(response?.data?.contractMarketBasketGridVO)
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setcontractmarketbasketgrid([]));
    });
};

// API to get contract  grids Reports data
export const getcontractgrid = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_CONTRACT_GRID, values)
    .then((response) => {
      dispatch(setLoading(false));
      const data = response?.data?.contractGridVO || [];
      data.sort((a, b) => a.contractSeqNum - b.contractSeqNum);
      return dispatch(setcontractgrid(data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setcontractgrid([]));
    });
};

// API to get contract detail report  data
export const getcontractdetailreport =
  (values, UserDefaultValues, logInUser) => (dispatch) => {
    dispatch(setLoading(true));
    return axios
      .post(serviceEndPoint.GET_CONTRACT_DETAIL_REPORT, values)
      .then((response) => {
        dispatch(setLoading(false));
        // ;
        if (response?.data?.contractDetailsVO?.length > 0) {
          dispatch(
            generateContractViewReport(
              response?.data?.contractDetailsVO[0],
              UserDefaultValues,
              logInUser
            )
          );
        } else {
          dispatch(showNoContractMessage());
        }

        //   return dispatch(setcontractgrid(response?.data?.contractGridVO));
      })
      .catch((response) => {
        dispatch(setLoading(false));
      });
  };
// API to get get contract seqnum mfg type
export const getcontractseqnummfgtype =
  (values, UserDefaultValues, view, validate) => (dispatch) => {
    dispatch(setLoading(true));
    return axios
      .post(serviceEndPoint.GET_CONTRACT_SEQNUM_MFG_TYPE, values)
      .then((response) => {
        dispatch(setLoading(false));
        // ;
        if (response?.data?.rebateContractMfgTypeSeqNumVO?.length !== 0) {
          if (view) {
            dispatch(
              getcontractdetailreport(
                {
                  contractId:
                    response.data.rebateContractMfgTypeSeqNumVO[0]
                      ?.contractSeqNum,
                },
                UserDefaultValues
              )
            );
          }
          if (validate) {
            dispatch(
              getContractValidationDetails({
                contractid:
                  response.data.rebateContractMfgTypeSeqNumVO[0]
                    ?.contractSeqNum,
              })
            );
          }
        } else {
          dispatch(showNoContractMessage());
        }

        //   return dispatch(setcontractgrid(response?.data?.contractGridVO));
      })
      .catch((response) => {
        dispatch(setLoading(false));
      });
  };

// API to get contract detail report  data
export const getContractDrugDetails =
  (values, UserDefaultValues, view, validate) => (dispatch) => {
    dispatch(setLoading(true));
    return axios
      .post(serviceEndPoint.GET_CONTRACT_DRUG_DETAILS, values)
      .then((response) => {
        dispatch(setLoading(false));
        // ;
        if (response?.data?.contractDrugDetailsVO?.length === 1) {
          if (view) {
            dispatch(
              getcontractdetailreport(
                {
                  contractId:
                    response.data.contractDrugDetailsVO[0]?.contractSeqNum,
                },
                UserDefaultValues
              )
            );
          }
          if (validate) {
            dispatch(
              getContractValidationDetails({
                contractid:
                  response.data.contractDrugDetailsVO[0]?.contractSeqNum,
              })
            );
          }
        } else if (response?.data?.contractDrugDetailsVO?.length > 1) {
          dispatch(
            setDrugFamilyContractGrid(response?.data?.contractDrugDetailsVO)
          );
          dispatch(setOpenValue(true));
        } else {
          dispatch(showNoContractMessage());
        }
      })
      .catch((response) => {
        dispatch(setLoading(false));
      });
  };

// API to get contract market basket seqnum
export const getContractMarketBasketSeqnum =
  (values, UserDefaultValues, view, validate) => (dispatch) => {
    dispatch(setLoading(true));
    return axios
      .post(serviceEndPoint.GET_CONTRACT_MARKET_BASKET_SEQNUM, values)
      .then((response) => {
        dispatch(setLoading(false));
        if (response?.data?.contractMarketBasketSeqNumVOt?.length === 1) {
          if (view) {
            dispatch(
              getcontractdetailreport(
                {
                  contractId:
                    response.data.contractMarketBasketSeqNumVOt[0]
                      ?.contractSeqNum,
                },
                UserDefaultValues
              )
            );
          }

          if (validate) {
            dispatch(
              getContractValidationDetails({
                contractid:
                  response.data.contractMarketBasketSeqNumVOt[0]
                    ?.contractSeqNum,
              })
            );
          }
        } else if (response?.data?.contractMarketBasketSeqNumVOt?.length > 1) {
          dispatch(
            setDrugFamilyContractGrid(
              response?.data?.contractMarketBasketSeqNumVOt
            )
          );
          dispatch(setOpenValue(true));
        } else {
          dispatch(showNoContractMessage());
        }
      })
      .catch((response) => {
        dispatch(setLoading(false));
      });
  };
